import { UserIdSchema } from "@core/domains/identity";
import { StageSchema } from "@core/foundation/stage";
import { z } from "@core/zod";

import { UserScopesSchema } from "./user-scope.ts";

export const UserRoleSchema = z.enum(["admin", "user"]);

export type UserRole = z.infer<typeof UserRoleSchema>;

export const UserClaimsSchema = z.object(
  {
    exp: z.number(),
    iat: z.number(),
    id: UserIdSchema,
    role: UserRoleSchema,
    scopes: UserScopesSchema,
    stage: StageSchema,
    type: z.literal("user"),
    version: z.literal(1),
  },
  {
    exp: "When the token expires, in seconds since the Unix epoch.",
    iat: "When the token was issued, in seconds since the Unix epoch.",
    id: "The id of the signed-in user.",
    role: "The user's role, admin or user.",
    scopes: "The scopes the user was granted at sign-in.",
    stage: "The stage the token was issued in.",
    type: "The token's kind, always user.",
    version: "The version of the claims' shape.",
  },
);

export interface UserClaims extends z.infer<typeof UserClaimsSchema> {}
